/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const NarrativeClassifierType = {
    GeminiClassifier: 'gemini_classifier',
    GeminiVideoClassifier: 'gemini_video_classifier'
} as const;
export type NarrativeClassifierType = typeof NarrativeClassifierType[keyof typeof NarrativeClassifierType];


export function instanceOfNarrativeClassifierType(value: any): boolean {
    for (const key in NarrativeClassifierType) {
        if (Object.prototype.hasOwnProperty.call(NarrativeClassifierType, key)) {
            if (NarrativeClassifierType[key as keyof typeof NarrativeClassifierType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function NarrativeClassifierTypeFromJSON(json: any): NarrativeClassifierType {
    return NarrativeClassifierTypeFromJSONTyped(json, false);
}

export function NarrativeClassifierTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): NarrativeClassifierType {
    return json as NarrativeClassifierType;
}

export function NarrativeClassifierTypeToJSON(value?: NarrativeClassifierType | null): any {
    return value as any;
}

export function NarrativeClassifierTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): NarrativeClassifierType {
    return value as NarrativeClassifierType;
}

